import { render, staticRenderFns } from "./ModalMenu.vue?vue&type=template&id=2b660a5a&"
import script from "./ModalMenu.vue?vue&type=script&lang=js&"
export * from "./ModalMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports